import * as React from 'react';
import { Box, Button, useMediaQuery, Theme, Menu } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { SxProps } from '@mui/system';
import { NavLink } from '../../model';
import { HeaderMenuItem } from './header-menu-item';
import { MoreMenuItem } from './more-menu-item';

export interface HeaderMenuProps {
  links?: NavLink[];
  smItems?: number;
  mdItems?: number;
  lgItems?: number;
  sx?: SxProps<Theme>;
  onLoading?: (loading: boolean) => void;
}

export function HeaderMenu(props: HeaderMenuProps) {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const handleMenuClick = () => {
    setAnchorEl(null);

    if (props.onLoading) {
      props.onLoading(true);
    }
  };

  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const matchesSm = useMediaQuery((theme: Theme) => theme.breakpoints.only('sm'));
  const matchesMd = useMediaQuery((theme: Theme) => theme.breakpoints.only('md'));
  const matchesLg = useMediaQuery((theme: Theme) => theme.breakpoints.only('lg'));

  const getMoreLinks = (links?: NavLink[]) => {
    if (links && links.length > (props.smItems ?? 3) && matchesSm) {
      return links.slice(props.smItems ?? 3, links.length);
    }

    if (links && links.length > (props.mdItems ?? 6) && matchesMd) {
      return links.slice(props.mdItems ?? 6, links.length);
    }

    if (links && links.length > (props.lgItems ?? 9) && matchesLg) {
      return links.slice(props.lgItems ?? 9, links.length);
    }

    return null;
  };

  const moreItems = getMoreLinks(props.links);

  if (!props.links || !props.links.length) {
    return <></>;
  }

  return (
    <Box sx={{ ml: 4, ...props.sx }}>
      {props.links &&
        props.links.map((link, index) => (
          <HeaderMenuItem
            key={link.id}
            link={link}
            index={index}
            smItems={props.smItems ?? 3}
            mdItems={props.mdItems ?? 6}
            lgItems={props.lgItems ?? 9}
            onClick={handleMenuClick}
          />
        ))}
      {moreItems && (
        <>
          <Button
            id="more-button"
            aria-controls="header-menu"
            aria-haspopup="true"
            aria-expanded={open ? 'true' : undefined}
            onClick={handleClick}
            color="secondary"
            sx={{
              mx: 1
            }}
            endIcon={<KeyboardArrowDownIcon />}
          >
            More
          </Button>
          <Menu
            id="more-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            MenuListProps={{
              'aria-labelledby': 'more-button'
            }}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'right'
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'right'
            }}
          >
            {moreItems.map((link) => (
              <MoreMenuItem key={link.id} menuLink={link} onClick={handleMenuClick} />
            ))}
          </Menu>
        </>
      )}
    </Box>
  );
}
